/**
 * CWR 2.4 — pinned hero caption (name + one-line summary) over the cover image.
 * Faithful to the mockup's .sd-hero / .sd-hero-cap (cover + center, focal-aware).
 */
import type { FocalPoint } from '@/api/types';
import { FocalImage } from '@/components/FocalImage';
import styles from '../SessionDetailPage.module.css';

export interface DetailHeroProps {
  name: string;
  summary: string | null;
  imageUrl: string | null;
  focalPoint: FocalPoint;
}

export function DetailHero({ name, summary, imageUrl, focalPoint }: DetailHeroProps) {
  const caption = (
    <>
      <div className={styles.heroCap}>
        <h1 className={styles.title}>{name}</h1>
        {summary && <p className={styles.subtitle}>{summary}</p>}
      </div>
    </>
  );

  return imageUrl ? (
    <FocalImage
      src={imageUrl}
      alt=""
      focalPointX={focalPoint.x}
      focalPointY={focalPoint.y}
      focalPointScale={focalPoint.scale}
      className={styles.hero}
      data-testid="detail-hero"
    >
      {caption}
    </FocalImage>
  ) : (
    <div className={`${styles.hero} ${styles.heroFallback}`} data-testid="detail-hero">
      {caption}
    </div>
  );
}
